'use client';
import React, { memo } from 'react';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

function IcAddCircleStroke(customProps) {
  const {
    fill,
    ...props
  } = customProps;
  useApplyLogging('ICON_IcAddCircleStroke');
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9 2.8C6.87421 2.8 2.8 6.87421 2.8 11.9C2.8 16.9258 6.87421 21 11.9 21C16.9258 21 21 16.9258 21 11.9C21 6.87421 16.9258 2.8 11.9 2.8ZM1 11.9C1 5.8801 5.8801 1 11.9 1C17.9199 1 22.8 5.8801 22.8 11.9C22.8 17.9199 17.9199 22.8 11.9 22.8C5.8801 22.8 1 17.9199 1 11.9Z",
    fill: fill || '#09AB49'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7999 7.575C12.7999 7.11937 12.4306 6.75 11.9749 6.75C11.5193 6.75 11.1499 7.11937 11.1499 7.575V11.15H7.575C7.11936 11.15 6.75 11.5193 6.75 11.975C6.75 12.4306 7.11936 12.8 7.575 12.8H11.1499V16.375C11.1499 16.8306 11.5193 17.2 11.9749 17.2C12.4306 17.2 12.7999 16.8306 12.7999 16.375V12.8H16.375C16.8306 12.8 17.2 12.4306 17.2 11.975C17.2 11.5193 16.8306 11.15 16.375 11.15H12.7999V7.575Z",
    fill: fill || '#09AB49'
  }));
}
var IcAddCircleStroke$1 = /*#__PURE__*/memo(IcAddCircleStroke);

export { IcAddCircleStroke$1 as default };
